import { useState } from 'react';

export default function useVisibility({ formIndex, name, defaultViewMode, useBusEffectOn }) {
  const [visibilityMode, setVisibilityMode] = useState(defaultViewMode ?? 'view');

  useBusEffectOn(`${formIndex}:visibility-mode-*`, mode => setVisibilityMode(() => mode));
  useBusEffectOn(`${formIndex}:${name}-visibility-mode`, mode => setVisibilityMode(() => mode));

  const isViewMode = visibilityMode === 'view';

  return { isViewMode, visibilityMode, setVisibilityMode };
}
